import { Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgModel, NG_VALIDATORS } from '@angular/forms';

import { EditWebcastModel } from '../editWebcast/EditWebcastModel';
import { ZoomService } from './Zoom.Service';
import { EditWebcastBaseSettingsComponent } from '../editWebcast/EditWebcastBaseSettings.Component';

import styles from '../editWebcast/EditWebcast.module.less';

@Component({
	selector: 'edit-webcast-zoom-input',
	templateUrl: './EditWebcastZoomInput.Component.html',
	providers: [{
		provide: NG_VALIDATORS,
		useExisting: forwardRef(() => EditWebcastZoomInputComponent),
		multi: true,
	}],
	standalone: false
})
export class EditWebcastZoomInputComponent extends EditWebcastBaseSettingsComponent implements OnInit {
	@Input() public webcast: EditWebcastModel;

	public readonly styles = styles;

	@ViewChild('zoomMeetingId')
	public zoomMeetingId: NgModel;

	constructor(
		public ZoomService: ZoomService
	) {
		super();
	}

	public ngOnInit(): void {
		if(!this.ZoomService.meetings) {
			this.ZoomService.loadMeetings();
		}
	}

	public ngAfterViewInit(): void {
		super.ngAfterViewInit();
		this.subscription.add(this.zoomMeetingId.valueChanges
			.subscribe(meeting => {
				this.ZoomService.meetings = this.ZoomService.filterMeetings(meeting) || [];
			}));
	}
}
